<template>
	<core-modal
		:name="campaign.id + '-split-modal'"
		class="omapi-modal split-modal"
		:clickToClose="!isCreatingSplit"
		@before-open="beforeOpen"
		:childRefs="$refs"
	>
		<template v-slot:header>
			<svg-split />
			Create a New Split Test
		</template>

		<modals-content>
			<transition name="component-fade-slow">
				<core-alert v-if="error" class="error">{{ error }}</core-alert>
			</transition>

			<p>Create a Split Test for the <strong>{{ campaign.name }}</strong> campaign.</p>

			<form @submit.prevent="split" class="omapi-modal-form">
				<section class="omapi-modal-form__section">
					<label :for="campaign.id + '-name'">Name</label>
					<input
						:id="campaign.id + '-name'"
						type="text"
						placeholder="Enter a name for your split test..."
						v-model="name"
						ref="toFocus"
					/>
				</section>

				<section class="omapi-modal-form__section">
					<label :for="campaign.id + '-notes'">Notes</label>
					<textarea
						:id="campaign.id + '-notes'"
						placeholder="Enter some notes about this split test..."
						v-model="notes"
					/>
				</section>

				<section v-if="availableTypes.length" class="omapi-modal-form__section">
					<label :for="campaign.id + '-type'">Campaign Type</label>
					<select
						:id="campaign.id + '-type'"
						v-model="type"
						:name="campaign.id + '-type'"
						required="required"
						placeholder="Select a Campaign Type"
					>
						<option
							v-for="(campaignType) in availableTypes"
							:key="campaignType.value"
							:value="campaignType.value"
						>{{ campaignType.name }}</option>
					</select>
				</section>

				<section
					class="omapi-modal-form__section"
					v-if="allowed('features', 'mobile-campaigns')"
					v-show="canMobile"
				>
					<label :for="campaign.id + '-mobile-toggle'">
						Mobile Campaign
					</label>
					<common-toggle-input
						:id="campaign.id + '-mobile-toggle'"
						v-model="mobile"
						:name="campaign.id + '-mobile-toggle'"
						wrapTag="span"
						onText="Yes"
						offText="No"
					/>
				</section>

				<section class="buttons">
					<core-loading-button
						class="split-campaign"
						size="large"
						color="blue"
						buttonType="submit"
						:loading="isCreatingSplit"
					>
						Create Split Test
					</core-loading-button>
					<core-button
						size="large"
						@click.prevent="$modal.hide(campaign.id + '-split-modal')"
						buttonType="button"
						:disabled="isCreatingSplit"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { split } from '@/campaigns/mixins/split'

export default {
	mixins : [ split ],
	props  : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	data () {
		return {
			name   : '',
			mobile : false,
			type   : '',
			notes  : null,
			error  : null,
		}
	},
	computed : {
		...mapGetters([ 'allowed' ]),
		...mapState('templates', [ 'permittedTypes', 'types' ]),
		availableTypes () {
			return this.permittedTypes
				.filter(type => {
					return !!this.types[ type ]
				})
				.map(type => {
					return {
						value : type,
						name  : this.types[ type ].name,
					}
				})
		},
	},
	methods : {
		beforeOpen () {
			this.name   = this.campaign.name
			this.mobile = Boolean(this.campaign.is_mobile)
			const type  = this.availableTypes.find(t => t.name === this.campaign.type)
			this.type   = type ? type.value : ''
		},
	},
	beforeDestroy () {
		this.error = null
		this.name  = null
		this.notes = null
	},
}
</script>
